export interface PeriodType {
  day: 'day';
  week: 'week';
  month: 'month';
  quarter: 'quarter';
  year: 'year';
}

/**
 * # periodType
 * Identifiers for all period types used in reporting
 */
export const PeriodTypeProvider: {
  provide: string;
  useValue: PeriodType;
} = {
  provide: 'periodType',
  useValue: {
    /**
     *
     * Daily report, scaled by hour
     */
    day: 'day',
    /**
     * Weekly report, scaled by day
     */
    week: 'week',
    /**
     *
     * Monthly report, scaled by day
     */
    month: 'month',
    /**
     *
     * Quarterly report, scaled by month
     */
    quarter: 'quarter',
    /**
     *
     * Yearly report, scaled by month
     */
    year: 'year',
  },
};
